






















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
// import { CouponsManageAPI } from "@/common/api/couponList";

import { excuteDownloadExport2Excel } from "@/common/xlsx";


import FreeOpenTableOptionListAPI from '@/common/api/operationManage/freeOpenTableOptionList';

import { DeepLoop } from "@/common/deepLoop/deepLoop";
import ZlSelect from "@/components/third-custom-components/select";

import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions,
  chineseNum2Ch
} from '@/common/config'

export const pageApiList = getPageAPIs(FreeOpenTableOptionListAPI)

const defaultForm = {
  mobile: "",
  shop_name: "",
  time: [],
  sort: ""
}

// 排序 空:全部 1.开台时长从高到低 2.开台时长从低到高 3.免费时长从高到低 4.免费时长从低到高 5.占比率的降序 6.占比率的升序
const sortOptions = [
  { value: "", label: "全部" },
  { value: "1", label: "开台时长从高到低" },
  { value: "2", label: "开台时长从低到高" },
  { value: "3", label: "免费时长从高到低" },
  { value: "4", label: "免费时长从低到高" },
  { value: "5", label: "占比率的降序" },
  { value: "6", label: "占比率的升序" }
];

// const defaultForms = {
//   machine_number: '', // 设备编码
//   fencheng_rate: '', // 分成比例
//   venue_id: "",
//   venue: {
//     id: "",
//     name: "",
//   },
// };

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

// const openTimeLevelRewardRecordDialogTitle2ch: any = {
//   "new-single-card-charge": "新增",
//   "edit-single-card-charge": "编辑",
// };

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;


const maxBenefitRate = 100

@Component({
  components: {
    ZlSelect,
    ZlOption,
  },
  filters: {
    showRankName(rank: number) {
      const rankName = chineseNum2Ch[rank]
      return rankName ? `第${rankName}名` : '未知'
    }
  }
})
export default class FreeOpenTableOptionsManage extends Vue {
  private sortOptions: any[] = sortOptions;

  // 增加时长弹框
  private isShowAddDurationDialog: boolean = false;
  private addDurationLoading: boolean = false;
  private addForms: any = { duration: "" };
  private currentRow: any = null;

  // 免费开台比例设置弹框
  private isShowRatioDialog: boolean = false;
  private ratioLoading: boolean = false;
  private ratioForms: any = { free_duration_rate: "" };

  private form: any = {
    // openTimeLevelRewardRecordId: "",
    // shop_name: "",
    // mobile: '',
    // order_no: '',
    // status: '',  // 状态：1提交订单 2已付款 3已取消 4已退款
    // time: [],
    // startDate: "",
    // endDate: "",
  };

  // private orderStatusList: any[] = [
  //   {
  //     label: '提交订单',
  //     value: 1,
  //   },
  //   {
  //     label: '已付款',
  //     value: 2
  //   },
  //   {
  //     label: '已取消',
  //     value: 3
  //   },
  //   {
  //     label: '已退款',
  //     value: 4
  //   },
  //   {
  //     label: '退款中',
  //     value: 5
  //   }
  // ]

  // private forms: any = {
  //   // maxType: "0",
  //   // ...defaultForms
  // };

  private deepLoopUtil: any = {};

  // private merchantApi: any;

  private freeOpenTableOptionListApi = new FreeOpenTableOptionListAPI();

  // private openTimeLevelRewardRecordTimeDurationAPI = new FreeOpenTableOptionTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    }

    // this.forms = {
    //   ...this.deepLoopUtil.deepCopy(defaultForms, false),
    // };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  private created(): void {
    this.getFreeOpenTableOptions();
  }
  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    }

    this.getFreeOpenTableOptions();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getFreeOpenTableOptions();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "100px";
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getFreeOpenTableOptions();
  }

  // 打开增加时长弹框
  private handleWakeAddDurationDialog(row: any) {
    this.currentRow = row;
    this.addForms = { duration: "" };
    this.isShowAddDurationDialog = true;
  }

  // 增加时长表单校验
  private getAddDurationParams(): any {
    if (!this.currentRow || this.currentRow.id === undefined || this.currentRow.id === null) {
      this.$message.error("缺少店铺信息");
      return false;
    }

    const duration = String(this.addForms.duration || "").trim();

    if (!duration) {
      this.$message.error("请输入时长");
      return false;
    }

    if (!/^\d+$/.test(duration) || Number(duration) < 1 || Number(duration) > 9999) {
      this.$message.error("时长为1-9999的整数");
      return false;
    }

    return {
      id: String(this.currentRow.id),
      duration,
    };
  }

  // 提交增加时长
  private submitAddDuration(): void {
    const params = this.getAddDurationParams();

    if (typeof params !== "object") {
      return;
    }

    this.addDurationLoading = true;
    this.freeOpenTableOptionListApi.addFreeOpenTableDuration(
      params,
      () => {
        this.addDurationLoading = false;
        this.isShowAddDurationDialog = false;
        Util.showToast("增加成功");
        this.getFreeOpenTableOptions();
      },
      () => {
        this.addDurationLoading = false;
      }
    );
  }

  // 免/总开台占比率展示，后端返回百分比数值，统一补 %
  private showFreeRate(rate: any): string {
    if (rate === null || rate === undefined || rate === "") {
      return "";
    }

    const rateStr = String(rate);

    return rateStr.endsWith("%") ? rateStr : `${rateStr}%`;
  }

  // 打开免费开台比例设置弹框
  private handleWakeRatioDialog(): void {
    this.ratioForms = { free_duration_rate: "" };
    this.isShowRatioDialog = true;
    this.getShopFreeConfig();
  }

  // 获取当前免费时长比例配置，无配置时按设计稿默认30
  private getShopFreeConfig(): void {
    this.freeOpenTableOptionListApi.getShopFreeConfig(
      {},
      (res: any) => {
        const rate = res && res.data ? res.data.free_duration_rate : "";

        if (rate !== "" && rate !== null && rate !== undefined) {
          this.ratioForms.free_duration_rate = String(rate);
        } else {
          this.ratioForms.free_duration_rate = "30";
        }
      },
      () => {
        this.ratioForms.free_duration_rate = "30";
      }
    );
  }

  // 比例设置表单校验
  private getRatioParams(): any {
    const rate = String(this.ratioForms.free_duration_rate || "").trim();

    if (!rate) {
      this.$message.error("请输入上月总开台时长比例");
      return false;
    }

    if (!/^\d+$/.test(rate) || Number(rate) < 20 || Number(rate) > 100) {
      this.$message.error("比例为20-100的整数");
      return false;
    }

    return {
      free_duration_rate: Number(rate),
    };
  }

  // 提交免费开台比例设置
  private submitRatio(): void {
    const params = this.getRatioParams();

    if (typeof params !== "object") {
      return;
    }

    this.ratioLoading = true;
    this.freeOpenTableOptionListApi.setShopFreeConfig(
      params,
      () => {
        this.ratioLoading = false;
        this.isShowRatioDialog = false;
        Util.showToast("设置成功");
        this.getFreeOpenTableOptions();
      },
      () => {
        this.ratioLoading = false;
      }
    );
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 导出字段先后顺序
  private excelSortList: string[] = [
    "shop_name",
    "mobile",
    "has_free",
    "add_duration",
    "use_free",
    "free_rate",
    "use_time",
    "operation_name",
    "operation_time",
  ];

  // 用户字段名 文案对应关系
  private excelList2ch: any = {
    shop_name: "店铺名称",
    mobile: "手机号",
    has_free: "免费时长（H）",
    add_duration: "增加时长（H）",
    use_free: "本月已免费开台时长（H）",
    free_rate: "免/总开台占比率",
    use_time: "时间",
    operation_name: "操作人",
    operation_time: "操作时间",
  };

  private handleDownloadExcel() {
    const params = this.getFreeOpenTableOptionParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;

    this.freeOpenTableOptionListApi.exportExcelFreeOpenTableOptionList(
      params,
      (res: any) => {
        const { start_date, end_date } = params || {};

        const filename = `免费开台店铺统计 ${start_date}到${end_date}.xlsx`;

        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item: any) => {
              const newItem = {
                ...(item || {}),
              };

              newItem.free_rate = this.showFreeRate(newItem.free_rate);

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const excelJSONData = getExcelJSONDataByList(
            newList,
            this.excelSortList,
            this.excelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.freeOpenTableOptionListApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
       
  //     }, 300);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }

  
  //获取充值列表
  private getFreeOpenTableOptions(): void {
    const params: any = this.getFreeOpenTableOptionParams()
    this.freeOpenTableOptionListApi.getFreeOpenTableOptionList(
      { ...params },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page || params.page;
        this.tablePage.prepage = res.data.prepage || params.limit;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getFreeOpenTableOptionParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { mobile, shop_name, time, sort } = form;


    if (mobile) {
      params.mobile = mobile
    }

    if (shop_name) {
      params.shop_name = shop_name
    }

    if (sort) {
      params.sort = sort;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      params.start_date = startDate;

      params.end_date = endDate;
    }

    if (
      mode == "exportExcel" &&
      !(params.start_date && params.end_date)
    ) {
      this.$message.error("请选择时段导出数据");
      return null;
    }

    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

    }

    if (mode === "exportExcel") {
      // 导出接口同样按分页结构返回，取首页最大分页量，避免被默认分页截断
      params.page = 1;

      params.limit = 500;
    }


    return params;
  }

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   reward_time_str: "时间",
  //   __rank_name: "排名",
  //   phone: "用户手机号",
  //   user_name: "用户昵称",
  //   minute: "本周开台时长（分钟）",
  //   reward_str: "奖励内容",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "reward_time_str",
  //   "__rank_name",
  //   "phone",
  //   "user_name",
  //   "minute",
  //   "reward_str",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getFreeOpenTableOptionParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  // //   this.freeOpenTableOptionListApi.exportExcelFreeOpenTableOptionList(
  //     params,
  //     (res: any) => {
  //       const { start_date, end_date } = params || {};

  //       const filename = `段位榜奖励记录列表 ${start_date}到${end_date}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { rank } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             const rankName = chineseNum2Ch[rank]

  //             newItem.__rank_name = rankName ? `第${rankName}名` : '未知'

             

  //             return newItem;
  //           })
  //         : [];

  //       // console.log(newList, 'newList')

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }
  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
